"use client";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";

export default function NoProductDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const router = useRouter();

  return (
    <Dialog open={open} onOpenChange={() => onClose()}>
      <DialogContent showCloseButton={false} className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl">등록된 상품이 없습니다.</DialogTitle>
          <DialogDescription>
            상품 관리 페이지로 이동하시겠습니까?
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2">
          <Button
            type="button"
            variant="secondary"
            onClick={() => {
              onClose();
            }}
          >
            취소
          </Button>
          <Button
            onClick={() => {
              router.push("/dashboard/product-management");
            }}
            type="button"
          >
            확인
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
